@if (ready()) {
  <div class="page">
    <nav class="navbar navbar-white bg-transparent rounded px-4">
      <div class="container-fluid">
        <span class="navbar-brand mb-0 h1">
          <div class="bg-white rounded-4 p-2 px-3 shadow-sm">
            <img src="assets/img/logo-veolia.png" alt="menu" height="23" class="mr-2" />
          </div>
        </span>
        <div class="d-flex mt-1">
          <div class="dropdown bg-white rounded-4" ngbDropdown>
            <button
              class="btn rounded-4 bg-white shadow-sm dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              ngbDropdownToggle
            >
              {{ user?.prenom | titlecase }}
              {{ user?.nom | titlecase }}
            </button>
            <ul
              class="dropdown-menu bg-white rounded-2 border-0 shadow-sm"
              aria-labelledby="dropdownMenuButton"
              ngbDropdownMenu
            >
              <li ngbDropdownItem class="bg-white">
                <a class="dropdown-item bg-white" href="#" (click)="logout()">Déconnexion</a>
              </li>
            </ul>
          </div>
          @if (adminToken) {
            <button class="btn btn-outline-danger rounded-4 ms-2" type="button" (click)="logoutSimulation()">
              Quitter la simulation
            </button>
          }
        </div>
      </div>
    </nav>

    <div id="main" class="main">
      <div class="text-center">
        @if (adminToken && droitId === UTILISATEUR_CLIENT) {
          <p>
            Pour accéder en tant que client, veuillez privilégier l'utilisation d'une cette application :
            <a [href]="waveClientUrl">{{ waveClientUrl }}</a>
            .
          </p>
        }
        @if (adminToken && droitId === UTILISATEUR_SOUS_TRAITANT) {
          <p>En tant que sous traitant, vous n'avez pas accès à cette plateforme pour le moment</p>
        }
      </div>
      <div class="tiles">
        @for (menu of userMenus; track menu) {
          <div class="tile tile-{{ menu.color }} cursor-pointer" (click)="navigateTo(menu)">
            <div class="tile-favorite">
              @if (menu.favorite) {
                <i-bs
                  name="star-fill"
                  width="1.1rem"
                  height="1.1rem"
                  (click)="changeFavorite(menu, false); $event.stopPropagation()"
                ></i-bs>
              } @else {
                <i-bs
                  width="1.1rem"
                  height="1.1rem"
                  name="star"
                  (click)="changeFavorite(menu, true); $event.stopPropagation()"
                ></i-bs>
              }
            </div>
            <div class="tile-icon tile-icon-{{ menu.color }} rounded rounded-2">
              <i-bs [name]="menu.icon" width="2rem" height="2rem"></i-bs>
            </div>
            <span class="tile-label">{{ menu.name }}</span>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <lib-loader id="loadInProgress"></lib-loader>
}
